export default __webpack_public_path__ + "static/media/Tick_signup.f654e270.svg";